import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { documentsActions } from '../../../application/actions/documents';
import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETBYID
export function* getByIdFetch(e) {
    yield put(documentsActions.conexionGetById({ connection: true }));
    try {
        const params = e.payload;
        const url = `document/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(documentsActions.getById({ data }));
    } catch (err) {
        yield put(documentsActions.errorGetById({ error: true, message: err.message }));
    } finally {
        yield put(documentsActions.conexionGetById({ connection: false }));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(documentsActions.conexionCreate({ connection: true }));
    try {
        const params = e.payload;
        console.log(params)
        const url = `document`
        const response = yield call(
            apiRequest.postFormData,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        if (result) {
            yield put(documentsActions.create({ result }));
        } else {
            const { error } = response
            yield put(documentsActions.errorCreate({ error: true, message: error }));
        }

    } catch (err) {
        yield put(documentsActions.errorCreate({ error: true, message: err.message }));
    } finally {
        yield put(documentsActions.conexionCreate({ connection: false }));
    }
}

// GETBYIDDONWLOAD
export function* getByIdDonwloadFetch(e) {
    yield put(documentsActions.conexionGetByIdDonwload({ connection: true }));
    try {


        const params = e.payload;
        const url = `document/${params.clientId}/${params.caseId}/${params.name}`
        const response = yield call(
            apiRequest.get,
            url,
            null,
            null,
            true
        );

        // Extraigo todos los datos
        console.log(response.byteLength)
        if (response.byteLength > 100) {
            yield put(documentsActions.getByIdDonwload({ result: true, buffer: response }));
        }else{
            yield put(documentsActions.errorgGetByIdDonwload({ error: true, message: 'error al cargar el archivo'}));
        }


    } catch (err) {
        yield put(documentsActions.errorgGetByIdDonwload({ error: true, message: err.message }));
    } finally {
        yield put(documentsActions.conexionGetByIdDonwload({ connection: false }));
    }
}



export function* watchFetchDocuments() {
    yield takeLatest(documentsActionsSaga.getById.type, getByIdFetch);
    yield takeLatest(documentsActionsSaga.create.type, createFetch);
    yield takeLatest(documentsActionsSaga.getByIdDonwload.type, getByIdDonwloadFetch);

}

export default function* rootSaga() {
    yield spawn(watchFetchDocuments);
}

const getById = createAction('documentsSaga/getById');
const create = createAction('documentsSaga/create');
const getByIdDonwload = createAction('documentsSaga/getByIdDonwload');

export const documentsActionsSaga = {
    getById,
    create,
    getByIdDonwload
};
